import React, { useEffect, useState } from 'react';
import { bool, func, node, string } from 'prop-types';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('ToggleSection');

const propTypes = {
    title: string.isRequired,
    description: string,
    openTitle: string,
    defaultOpen: bool,
    open: bool,
    onToggle: func,
    className: string,
    headerClassName: string,
    type: string,
    children: node,
    track: func,
};

const ToggleSection = (props) => {
    const {
        title,
        openTitle,
        description,
        className,
        headerClassName,
        type = '',
        children,
        onToggle,
        defaultOpen = false,
        open: openProps = false,
        track,
    } = props;
    const [openState, setOpenState] = useState(defaultOpen || openProps);
    const open = onToggle ? openProps : openState;

    const handleClick = () => {
        onToggle ? onToggle() : setOpenState((prevOpen) => !prevOpen);
    };

    useEffect(() => {
        track?.(open);
    }, [open]);

    return (
        <div className={bem(null, null, className)}>
            <header className={bem('header', { open }, headerClassName)}>
                <button type="button" className={bem('button', [type, open ? 'open' : undefined])} onClick={handleClick}>
                    {open && openTitle ? openTitle : title}
                    {description ? <div className={bem('description')}>{description}</div> : null}
                </button>
            </header>
            <div className={bem('content', { open })}>{children}</div>
        </div>
    );
};

ToggleSection.propTypes = propTypes;

export default ToggleSection;
